import { render, staticRenderFns } from "./SatisTeklifleri.vue?vue&type=template&id=2062de88&"
import script from "./SatisTeklifleri.vue?vue&type=script&lang=js&"
export * from "./SatisTeklifleri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports